import { rule, match, number, minMaxLength, every, boolTrue } from 'components/Shared/Form/rules';
import { rm } from 'utils';

export { isValidEmail } from 'components/Shared/Form/rules';

export const identityNumberRegexString =
  '^(19|20)?([0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1]))-?([0-9]{4})$';
export const organizationNumberRegexString = '^[0-9]{6}-?[0-9]{4}$';
export const phoneNumberRegexString = '^07([0-9][ -]*){7}[0-9]$';
const orderNumberRegexString = /^(SO)?\d{1,}$/i

const identityNumberRegex = new RegExp(identityNumberRegexString);
const organizationNumberRegex = new RegExp(organizationNumberRegexString);
const phoneNumberRegex = new RegExp(phoneNumberRegexString);
const orderNumberRegex = new RegExp(orderNumberRegexString);

export const isValidOrderNumber = match(orderNumberRegex)
export const isValidPhoneNumber = match(phoneNumberRegex);
export const phone = rule(() => rm('checkout_error_cellphone'), isValidPhoneNumber);

export const isValidIdentityNumber = match(identityNumberRegex);
export const isValidOrganizationNumber = match(organizationNumberRegex);

export const identityNumber = rule(() => rm('checkout_identity_error'), isValidIdentityNumber);
export const organizationNumber = rule(
  () => rm('checkout_identity_company_error'),
  isValidOrganizationNumber
);

export const ZIP_CODE_LENGTH = 5;
export const isValidZipcode = every(number, minMaxLength(ZIP_CODE_LENGTH, ZIP_CODE_LENGTH));

export const zip = rule(() => rm('checkout_error_zip_city'), isValidZipcode);

export const confirmCertificate = rule(() => rm('checkout_certificate_confirm_error'), boolTrue);

export * from '../default/validation';
